/*
    * 重要参数分离
*/
export function getAttr(arr) {
    /* 匹配对应的重要参数 */
    arr.forEach((item) => {
        item.nNum = 1;
        item.attr_one = []; // 右边重要卖点
        item.attr_two = []; // 下面参数
        item.attr.forEach((it) => {
            it.attr_name = it.attr_name
                .replace(/[\r\n]/g, "")
                .replace(/\ +/g, ""); // 过滤空格、换行
            it.attr_value = it.attr_value
                ? it.attr_value
                    .replace(/[\r\n]/g, "")
                    .replace(/\ +/g, "")
                : ""; // 过滤空格、换行
            if (
                it.attr_mean == 1 ||
                it.attr_mean == 2 ||
                it.attr_mean == 3
            ) {
                // 右边重要卖点分离
                item.attr_one.push(it);
            }
            if (
                it.attr_mean == 4 ||
                it.attr_mean == 5 ||
                it.attr_mean == 6
            ) {
                // 下面参数分离
                item.attr_two.push(it);
            }
        });
    });
    return arr
}
/*
    * 调用负荷计算接口
*/
export function getRoomEnergy(oRes, area) {
    let data = {
        energy_cold: oRes.energy_cold,
        energy_cold_per: oRes.energy_cold_per,
        energy_cold_per_warp:
            Number(oRes.energy_cold / area).toFixed(2),
        energy_hot_per_warp:
            Number(oRes.energy_hot / area).toFixed(2),
        energy_cold_area: oRes.energy_cold_area,
        energy_hot_per: oRes.energy_hot_per,
        energy_hot: oRes.energy_hot,
        energy_hot_area: oRes.energy_hot_area,
        energy_out: oRes.energy_out,
        energy_percent: oRes.energy_percent,
    }
    return data
}
/*
    * 匹配风盘的方法
*/
export function getFather(arrRooms, arrSetWind) {
    let arrFter = arrRooms.arrWind.filter((it) => {
        return it.new_goods_type_id == 201;
    });
    if (arrFter.length) {
        for (var i = arrRooms.arrWind.length - 1; i >= 0; i--) {
            if (arrRooms.arrWind[i].new_goods_type_id == 201) {
                arrRooms.arrWind.splice(i, 1);
            }
        }
    }
    // 通过find  输出比房间符合大的风盘
    let oWind = arrSetWind.find((wit) => {
        return wit.power >= arrRooms.energy_cold;
    });
    if (!arrRooms.noMatch) {
        /* 如果有合适功率风盘则添加，没有则添加最大功率疯盘 */
        if (oWind) {
            arrRooms.arrWind.push(oWind);
        } else {
            //没有匹配到合适的风盘
            //先选出最大功率的风盘
            let nMaxPower = Math.max.apply(
                Math,
                arrSetWind.map((item) => {
                    return item.power;
                })
            );
            let oMaxWind = arrSetWind.find((it) => {
                return nMaxPower == it.power;
            });
            let nNum = Math.floor(
                arrRooms.energy_cold / oMaxWind.power
            );
            for (var i = 0; i < nNum; i++) {
                arrRooms.arrWind.push(oMaxWind);
            }
            /* 判断功率是否达到需求功率，没有达到的话，算出确实的功率值，根据缺少值匹配功率最相近的风盘 */
            let nAllPower = nNum * oMaxWind.power;
            let nDifference = arrRooms.energy_cold - nAllPower;
            // 根据差值匹配功率最相近的风盘
            if (nDifference > 0) {
                let oWind = arrSetWind.find((wit) => {
                    return wit.power >= nDifference;
                });
                arrRooms.arrWind.push(oWind);
            }
        }
    }
}

/*
    * 散热匹配方法
*/
export function getDissipate(arrRooms, arrHeatSink) {
    let arrRemainder = []; //余数取值范围
    let arrNumBer = []; //余数0的整数取值
    let arrZshuDer = []; //整数取值范围
    let arrRemaShopp = []; //余数为0的商品
    let arrMaxRemaShopp = []; //余数大于0的商品
    let arrMaxNumBer = []; //余数大于0的整数取值
    let area = arrRooms.area; //房间面积
    if (arrHeatSink.length) {
        arrHeatSink.forEach((it) => {
            let num = Number(Number(area % it.power)); //取余数
            let snum = Number(
                Number(area / it.power).toFixed(0)
            ); //取整数
            if (num == 0) {
                //获取余数为0的散热器
                arrRemaShopp.push(it);
                arrNumBer.push(snum);
            } else {
                //获取余数不为0的散热器
                arrMaxRemaShopp.push(it);
                arrMaxNumBer.push(snum);
            }
            //获取所有的散热器
            arrRemainder.push(num);
            arrZshuDer.push(num);
        });
        let arrFatal = arrRemainder.filter((it) => {
            return it == 0;
        });
        let arrMaxFatal = arrRemainder.filter((it) => {
            return it > 0;
        });
        if (arrFatal.length) {
            //当余数为0 且数量为<2时，获取最小值  拿到匹配最优数据push到 arrRooms.arrWind
            if (arrFatal.length < 2) {
                let minNum = Math.min(...arrNumBer);
                let minIndex = arrNumBer.indexOf(minNum);
                let objShoppGood = arrRemaShopp[minIndex];
                for (let i = 0; i < minNum; i++) {
                    arrRooms.arrWind.push(objShoppGood);
                }
            } else {
                //当余数为0 且数量为>2时，获取最小值  拿到匹配最优数据push到 arrRooms.arrWind
                let minBunerNum = Math.min(...arrNumBer);
                let minShoppIndex =
                    arrNumBer.indexOf(minBunerNum);
                let objMinShoppGood =
                    arrRemaShopp[minShoppIndex];
                for (let i = 0; i < minBunerNum; i++) {
                    arrRooms.arrWind.push(objMinShoppGood);
                }
            }
        } else if (arrMaxFatal.length) {
            //当余数不为0 ，获取最小值  拿到匹配最优数据push到 arrRooms.arrWind
            let minNumFatal = Math.min(...arrMaxNumBer);
            let minShoppFatalIndex =
                arrMaxNumBer.indexOf(minNumFatal);
            let objMinShoppFatalGood =
                arrMaxRemaShopp[minShoppFatalIndex];
            for (let i = 0; i < minNumFatal; i++) {
                arrRooms.arrWind.push(objMinShoppFatalGood);
            }
        }
    } else {
        this.$toast("暂无散热片系统！");
        arrRooms.typeXuan.forEach((xit) => {
            if (xit.id == 2) {
                xit.open = false;
            }
        });
    }
    return arrRooms
}
/*
    * 删除风盘
*/
export function getDelShopp(is_shopp,windex) {
    let arrSr = is_shopp.arrWind.filter((items) => {
        return items.new_goods_type_id == 215;
    });
    let arrDn = is_shopp.arrWind.filter((items) => {
        return items.new_goods_type_id == 216;
    });
    let arrFp = is_shopp.arrWind.filter((items) => {
        return items.new_goods_type_id == 201;
    });
    if (arrSr.length) {
        is_shopp.typeXuan[1].open = true;
        is_shopp.typeXuan[2].open = false;
    } else {
        is_shopp.typeXuan[1].open = false;
    }
    if (arrDn.length) {
        is_shopp.typeXuan[1].open = false;
        is_shopp.typeXuan[2].open = true;
    } else {
        is_shopp.typeXuan[2].open = false;
    }
    if (arrFp.length) {
        is_shopp.typeXuan[0].open = true;
    } else {
        is_shopp.typeXuan[0].open = false;
    }
    return is_shopp
}

/*
    * 添加楼层需要的数据
*/
export function getAddRoom(nFloorTypeIndex, arrRoom) {
    let oObj = {};
    if (nFloorTypeIndex == 0) {
        // 楼层
        if (arrRoom.length) {
            /* 找出当前最高楼层，楼层+1 room+1 */
            let nMax = Math.max(...arrRoom);
            oObj = {
                room: nMax + 1,
                num_bed: 0,
                num_hall: 0,
                num_toilet: 0,
                // num_kitchen: 0,
                num_veranda: 0,
            };
        } else {
            oObj = {
                room: 1,
                num_bed: 0,
                num_hall: 0,
                num_toilet: 0,
                // num_kitchen: 0,
                num_veranda: 0,
            };
        }
    } else if (nFloorTypeIndex == 1) {
        // 地下室
        if (arrRoom.length) {
            /* 找出当前最底楼层，楼层-1  room-1 */
            let nMin = Math.min(...arrRoom);
            oObj = {
                room: nMin == 1 ? -1 : nMin - 1,
                num_bed: 0,
                num_hall: 0,
                num_toilet: 0,
                // num_kitchen: 0,
                num_veranda: 0,
            };
        } else {
            oObj = {
                room: -1,
                num_bed: 0,
                num_hall: 0,
                num_toilet: 0,
                // num_kitchen: 0,
                num_veranda: 0,
            };
        }
    }
    return oObj
}


/*
    * 当前选择了风盘匹配、散热器匹配、地暖匹配
*/
export function getStuyType(xinde, is_shopp) {
    // 判断是否选中 地暖管  (地暖系统不能与散热器同时存在 2为散热器  3为地暖系统)
    if (is_shopp.typeXuan[xinde].id == 2) {
        if (is_shopp.typeXuan[xinde + 1].open) {
            is_shopp.typeXuan[xinde + 1].open = false;
        }
    } else if (is_shopp.typeXuan[xinde].id == 3) {
        if (is_shopp.typeXuan[xinde - 1].open) {
            is_shopp.typeXuan[xinde - 1].open = false;
        }
    }
    // 可选中和取消选中
    is_shopp.typeXuan[xinde].open = !is_shopp.typeXuan[xinde].open;
    // 判断选中的是(风盘、散热、地暖系统)
    let arrOpenType = is_shopp.typeXuan.filter((it) => {
        return it.open == true;
    });
    // 因为可以多选，风盘可以和散热、地暖系统独立存在、这里数组长度为2时、判断时散热片还是风盘
    if (arrOpenType.length == 2) {
        //判断选中的选型中是有散热片还是风盘
        let arrTypeList = arrOpenType.filter((it) => {
            return it.id == 2;
        });
        // arrTypeList.length 有长度表示 选中了散热片   没有长度表示选中了地暖
        if (arrTypeList.length) {
            // 选中散热片  就需要把地暖管所有商品删除   id=216 为地暖管  215为散热片  201为 风盘
            for (var i = is_shopp.arrWind.length - 1; i >= 0; i--) {
                if (is_shopp.arrWind[i].new_goods_type_id == 216) {
                    is_shopp.arrWind.splice(i, 1);
                }
            }
        } else {
            // 选中地暖管  就需要把散热片所有商品删除
            for (var i = is_shopp.arrWind.length - 1; i >= 0; i--) {
                if (is_shopp.arrWind[i].new_goods_type_id == 215) {
                    is_shopp.arrWind.splice(i, 1);
                }
            }
        }
    } else if (arrOpenType.length == 1) {
        // 判断选中的选型中是有散热片还是风盘还是地暖管
        // 是否有地暖管
        let arrThreeTypeList = arrOpenType.filter((it) => {
            return it.id == 3;
        });
        // 是否有散热片
        let arrOneTypeList = arrOpenType.filter((it) => {
            return it.id == 2;
        });
        // 是否有风盘
        let arrTwoTypeList = arrOpenType.filter((it) => {
            return it.id == 1;
        });
        if (arrTwoTypeList.length) {
            // 当风盘点亮时删除除风盘以外所有商品
            for (var i = is_shopp.arrWind.length - 1; i >= 0; i--) {
                if (
                    is_shopp.arrWind[i].new_goods_type_id == 215 ||
                    is_shopp.arrWind[i].new_goods_type_id == 216
                ) {
                    is_shopp.arrWind.splice(i, 1);
                }
            }
        }
        // 当散热片点亮时删除除散热片以外所有商品
        if (arrOneTypeList.length) {
            for (var i = is_shopp.arrWind.length - 1; i >= 0; i--) {
                if (
                    is_shopp.arrWind[i].new_goods_type_id == 201 ||
                    is_shopp.arrWind[i].new_goods_type_id == 216
                ) {
                    is_shopp.arrWind.splice(i, 1);
                }
            }
        }
        // 当地暖管点亮时删除除地暖管以外所有商品
        if (arrThreeTypeList.length) {
            for (var i = is_shopp.arrWind.length - 1; i >= 0; i--) {
                if (
                    is_shopp.arrWind[i].new_goods_type_id == 201 ||
                    is_shopp.arrWind[i].new_goods_type_id == 215
                ) {
                    is_shopp.arrWind.splice(i, 1);
                }
            }
        }
        // 当全部未选中时商品内容置空
    } else if (arrOpenType.length == 0) {
        is_shopp.arrWind = [];
    }
    return is_shopp
}

/*
    * 返回东南西北系数
*/
export function getDire(it) {
    switch (it.direction) {
        case "南":
            return 0;
            break;
        case "北":
            return 1;
            break;
        case "东":
            return 2;
            break;
        case "西":
            return 3;
            break;
        case "东南":
            return 4;
            break;
        case "西南":
            return 5;
            break;
        case "东北":
            return 6;
            break;
        case "西北":
            return 7;
            break;
        case "无/未知":
            return 9;
            break;
        default:
            return 9;
            break;
    }
}

export function getDireBack(it) {
    switch (it.direction) {
        case 0:
            return "南";
        case 1:
            return "北";
        case 2:
            return "东";
        case 3:
            return "西";
        case 4:
            return "东南";
        case 5:
            return "西南";
        case 6:
            return "东北";
        case 7:
            return "西北";
        case 9:
            return "无/未知";
    }
}
